

export type DebitRejectionsTabsKeyValues = DEBIT_REJECTIONS_TABS_KEY_VALUES; 
export enum DEBIT_REJECTIONS_TABS_KEY_VALUES {
    REJECTIONS_CREDITS = '1',
    REJECTIONS_DEBITS = '2',
}